<template>
  <b-modal
    :id="`modal-question-order_${id}`"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    title="Order"
    ok-title="OK"
    cancel-variant="outline-secondary"
    size="lg"
    @ok="handleOk"
    @shown="initQuestions"
  >
    <draggable
      v-model="questionArray"
      class="cursor-move"
      tag="div"
    >
      <b-badge
        v-for="(q, index) in questionArray"
        :key="'question'+index"
        tag="div"
        variant="success"
        style="margin:3px"
      >{{ findQuestionText(q) }}</b-badge>
    </draggable>

  </b-modal>
</template>

<script>
import {
  BModal, VBModal, BBadge,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'

export default {
  components: {
    BModal,
    draggable,
    BBadge,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      questionArray: [],
    }
  },
  methods: {
    findQuestionText(q) {
      // Find the question text based on the question name
      const question = this.options.find(x => x.questionName === q || x === q)
      return question ? (question?.questionText || question) : ''
    },
    initQuestions() {
      // Initialize the questionArray with a deep copy of the questions prop
      this.questionArray = JSON.parse(JSON.stringify(this.questions))

      console.log('this.questionArray', this.questionArray)
      console.log('this.options', this.options)
    },
    handleOk() {
      // Trigger submit handler
      this.$emit('submit', this.questionArray.map(x => x))
    },
  },
}
</script>
